const BRUSH_RADIUS = 80;

class SwipeReveal {
    constructor(el, image) {
        this.el = el;
        this.image = image;
        this.canvas = null;
        this.ctx = null;

        this.createCanvas();
    }

    get imgPath() {
        return `${this.constructor.theme}/assets/images/swipe-reveal/`;
    }

    createCanvas() {
        const bridgeContainer = document.createElement("figure");
        bridgeContainer.setAttribute("id", "bridgeContainer");
        this.canvas = document.createElement("canvas");
        this.canvas.setAttribute("id", "bridge");
        this.canvas.style.setProperty(
            "cursor",
            `url(${this.imgPath}circular-cursor.png) 53 53, crosshair`
        );
        this.ctx = this.canvas.getContext("2d", { willReadFrequently: true });
        this.setCanvasSize();
        bridgeContainer.appendChild(this.canvas);
        this.el.appendChild(bridgeContainer);

        this.canvas.style.setProperty(
            "background-image",
            `url(${this.image.src})`
        );

        this.image.onload = () => {
            this.ctx.drawImage(
                this.image,
                0,
                0,
                this.canvas.width,
                this.canvas.height
            );
        };

        this.image.src = `${this.imgPath}overlay.jpg`;

        this.canvas.addEventListener(
            "mousemove",
            (e) => {
                const brushPos = this.getBrushPos(e.clientX, e.clientY);
                const leftBut = this.detectLeftButton(e);

                if (leftBut == 1) {
                    this.drawDot(brushPos.x, brushPos.y);
                }
            },
            false
        );

        this.canvas.addEventListener(
            "touchmove",
            (e) => {
                e.preventDefault();
                const touch = e.targetTouches[0];

                if (touch) {
                    var brushPos = this.getBrushPos(touch.pageX, touch.pageY);
                    this.drawDot(brushPos.x, brushPos.y);
                }
            },
            false
        );
    }

    setCanvasSize() {
        this.canvas.setAttribute("width", `${this.el.offsetWidth}px`);
        this.canvas.setAttribute("height", `${this.el.offsetHeight}px`);
    }

    detectLeftButton(event) {
        if ("buttons" in event) {
            return event.buttons === 1;
        } else if ("which" in event) {
            return event.which === 1;
        } else {
            return event.button === 1;
        }
    }

    getBrushPos(xRef, yRef) {
        let bridgeRect = this.canvas.getBoundingClientRect();

        return {
            x: Math.floor(
                ((xRef - bridgeRect.left) /
                    (bridgeRect.right - bridgeRect.left)) *
                    this.canvas.width
            ),
            y: Math.floor(
                ((yRef - bridgeRect.top) /
                    (bridgeRect.bottom - bridgeRect.top)) *
                    this.canvas.height
            ),
        };
    }

    drawDot(mouseX, mouseY) {
        this.ctx.beginPath();
        this.ctx.arc(mouseX, mouseY, BRUSH_RADIUS - 12, 0, 2 * Math.PI, true);

        this.ctx.shadowBlur = 90;
        this.ctx.shadowColor = "rgba(0,0,0,1)";
        this.ctx.shadowOffsetX = 0;
        this.ctx.shadowOffsetY = 0;
        this.ctx.fillStyle = "#000";
        this.ctx.globalCompositeOperation = "destination-out";
        this.ctx.fill();
    }
}

export default SwipeReveal;
